import axios from "axios";
import { UpdatedLocationDetails } from "@/redux/slice/location/types/UpdatedLocationDetails";
import {
  NEXT_PUBLIC_PHARMACY_SERVICEABILITY_API_BASE_URL,
  NEXT_PUBLIC_PHARMACY_SERVICEABILITY_TOKEN,
} from "@/libs/constants/location";

const checkServiceAvailability = async ({ pincode, latitude, longitude, authToken }: UpdatedLocationDetails) => {
  const latLngParams = `latitude=${latitude}&longitude=${longitude}`;
  const pincodeParams = `pincode=${pincode}`;

  return await axios
    .get(
      `${NEXT_PUBLIC_PHARMACY_SERVICEABILITY_API_BASE_URL}/v1/geocode/serviceable?${
        latitude && longitude
          ? `${latLngParams}${pincode ? `&${pincodeParams}` : ``}`
          : `${pincode ? `${pincodeParams}` : ``}`
      }`,
      {
        headers: {
          Authorization: authToken ? authToken : NEXT_PUBLIC_PHARMACY_SERVICEABILITY_TOKEN,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => {
      try {
        const {
          axdcCode = "",
          isServiceable: serviceable = false,
          city = "",
          state = "",
          pincode = "",
          latitude,
          longitude,
          tatInput,
        } = res?.data?.data?.data || {};
        serviceable && sessionStorage.setItem("axdcCode", axdcCode as string);
        sessionStorage.setItem("serviceableCity", city);

        return {
          axdcCode,
          serviceable,
          city,
          state,
          pincode,
          latitude,
          longitude,
          tatInput,
        };
      } catch (e) {
        return {
          axdcCode: "",
          serviceable: false,
          city: "",
          state: "",
          pincode: "",
          latitude: null,
          longitude: null,
          tatInput: "",
        };
      }
    })
    .catch((err) => {
      console.error("Serviceable API failed to get response", err);

      return null;
    });
};

export default checkServiceAvailability;
